import * as Sentry from "@sentry/browser"

const sentryDsn = document.querySelector('meta[name="sentry-dsn"]')?.content
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: document.querySelector('meta[name="sentry-environment"]')?.content,
    defaultIntegrations: false,
    integrations: [
      Sentry.globalHandlersIntegration(),
      Sentry.dedupeIntegration(),
    ],
  })
}
